<template>
    <div class="pe_ds-container">
      <div class="pe_archive_close-button">
        <router-link class="pe_btn pe_back" to="/">X</router-link>
      </div>
  <div><h1 style="color:#fff;">Archive</h1></div>
      <div v-for="(value, key) in archiveData" :key="key" class="pe_archive_main-content">
      <div @click="toggleItem(key)" class="pe_archive-btn">
        {{ formatDate(key) }}
      </div>
      <transition name="fade"></transition>
      <div v-show="activeItem === key" class="pe_ds-button-container">

          <button
              v-for="item in value"
              :key="item.puzzleId"
              @click="goToPuzzleRoute({ router: $router, id: item.puzzleId, desc: item.description.replace() })"
              :class="['pe_ds-sub-button', 'pe_tooltip',getPuzzleState(item.puzzleId)]"
            >
              <component v-bind:is="getPuzzleState(item.puzzleId)" class="pe_logo" />
                <!--<span class="pe_tooltiptext">
                    {{ friendlyLevelName(item.description.replace()) }}
                </span>-->
                <span>
                  {{ friendlyLevelName(item.description.replace()) }}
                </span>
            </button>
            
      </div>
    </div>

    </div>
  </template>
  
  <script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import HourGlass from '@puzzleapps/shared/src/components/ui/icons/HourGlass';
  import Trophy from '@puzzleapps/shared/src/components/ui/icons/Trophy';
  import Play from '@puzzleapps/shared/src/components/ui/icons/Play';
  import Arrow from '@puzzleapps/shared/src/components/ui/icons/Arrow';
  
  export default {
    name: 'archive',
  
    props: [],
  
    components: {
      'started': HourGlass,
      'completed': Trophy,
      'ready': Play,
      'Arrow': Arrow,
    },
  
    mounted() {
      this.setArchiveFromApi(window.PE_CLIENTAPP_ID);
    },
  
    data() {
        return { 
            activeItem: null
        };
        
    },
  
    methods: {
        ...mapActions({
            setArchiveFromApi: 'archive/setArchiveFromApi',
            goToPuzzleRoute: 'game/goToPuzzleRoute',
            toggleArchiveDataShowDiv: 'archive/toggleArchiveDataShowDiv',
        }),
  
      toggleDiv(index) {
        alert(index)
        this.toggleArchiveDataShowDiv(index);
        },

        toggleItem(key) {
            this.activeItem = (this.activeItem === key) ? null : key;
    },
      
      formatDate(date) {
        return new Date(date).toLocaleDateString('en-UK', {
          weekday: 'short',
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });
      },

      friendlyLevelName(input){
        var levelFriendlyName = input
        if (input.includes('Level 1')) {
            levelFriendlyName = "Easy"
          }
          else if (input.includes('Level 2')) {
            levelFriendlyName = "Medium"
          }
          else if (input.includes('Level 3')) {
            levelFriendlyName = "Hard"
          }
          else if (input.includes('Level 4')) {
            levelFriendlyName = "Difficult"
          }
          else if (input.includes('Level 5')) {
            levelFriendlyName = "Genius"
          }

          return levelFriendlyName
      },
    },
  
    computed: {
      ...mapState({
        archiveData: state => state.archive.data,
        gameType: state => state.game.type,
      }),
  
      ...mapGetters({
        getPuzzleState: 'archive/getLocalPuzzleState',

      }),
    },


  };
  </script>
  
  <style scoped lang="scss">
  @import '~@puzzleapps/shared/src/style/variables';
  #puzzleapp{

    .pe_logo {    
        width: 70px;
        max-width: 100%;
        //height: 94px;
        //margin-right: 1em;
        //margin-top: 1em;

        @media (max-width: 470px) {
            //margin-right: 4vw;
            width: 5vw;
            height: 10vw;
        }
    }
  .pe_ds-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    background: #222222ea;
    color: #fff;
    width: 100%;
    z-index: 999;
    top: 0;
    left: 0;

    .pe_archive-btn{

        border: 2px solid  rgba(0, 0, 0, 0.13);
        border-radius: 4px;
        bottom: 0px;
        box-sizing: border-box;
        cursor: pointer;
        //display: inline-flex;
        font-family: Poppins, Helvetica, Arial, sans-serif;
        font-size: 17.2px;
        font-weight: 600;
        //justify-content: center;
        left: 0px;
        letter-spacing: 1px;
        // line-height: 1;
        //margin: 0.8em 0;
        padding: 0.9em;
        margin-bottom: 5px;
        //position: relative;
        // right: 0px;
        text-decoration: none;
        top: 0px;
        transition: all 0.2s ease 0s;
        width: 250px;
        height: 55px;

        background:  var(--sudoku-menu-btn-hover) none repeat scroll 0% 0% / auto padding-box border-box;
        color: #000;
        &:hover{
        background: var(--sudoku-menu-btn-background);
        } 
        /* &.started{
        background: var(--codecracker-menu-btn-background);
        &:hover{
            background: var(--codecracker-menu-btn-hover); 
        }
        }*/
        &.completed{
        background: var(--codecracker-menu-btn-background);
        &:hover{
            background: var(--codecracker-menu-btn-hover); // #11d37c;
        }
        }
    }
    .pe_archive_main-content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
  }
  
  .pe_archive_close-button {
    align-self: flex-end;
    padding: 10px;
    cursor: pointer;
    font-size: 1.5em;
  }
  
  .pe_ds-button-container {
    display: flex;
    justify-content: center;
    //width: 80%;
    flex-wrap: wrap;
    
  }
  
  .pe_ds-main-button {
    width: 100%;
  }
  
  .pe_ds-content {
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
  }
  
  .pe_ds-sub-button {
    flex: 1;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //margin-right: 5px;
    border-radius: 4px;
    //margin-bottom: 5px;
    min-width: 70px;
    font-family: $primary-font!important;
    font-size: smaller;
    cursor: pointer;
  }
  .pe_tooltip {
        position: relative;
        //display: inline-block;
        //border-bottom: 1px dotted black;
        }

    .pe_tooltip .pe_tooltiptext {
        visibility: hidden;
        width: 120px;
        background-color: #fff;
        color: #000;
        text-align: center;
        font-weight: 600;
        border-radius: 6px;
        padding: 5px 0;

        /* Position the tooltip */
        position: absolute;
        z-index: 1;
        bottom: -30px;
        left: -30px;
    }

    .pe_tooltip:hover .pe_tooltiptext {
        visibility: visible;
    }
}
  </style>
  